$(function () {
    $('[data-carousel]').each(function () {
        var swiper = new Swiper(this, {
            slidesPerView: 1,
            loop: true,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                },
            }
        });
        const $this = $(this);
        const outerContainerSelector = $this.data('carousel-container');
        (outerContainerSelector && $this.closest(outerContainerSelector) || $this).find('.swiper-controls .btn').on('click', function (ev) {
            ev.preventDefault();
            if ($(this).data('carousel-move') === 'prev') {
                swiper.slidePrev();
            } else {
                swiper.slideNext();
            }
        });
    });
});